function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { getPathValue } from './utils';
import ComparisonViewContext from './comparison-view-context';

// tslint:disable-next-line:function-name
function RowGroup(props) {
  var _row$title, _ref, _row$key, _row$align, _classnames;

  var row = props.row,
      dataSource = props.dataSource,
      getColKey = props.getColKey,
      getColClassName = props.getColClassName,
      groupIndex = props.index,
      onColMouseEnter = props.onColMouseEnter,
      onColMouseLeave = props.onColMouseLeave;
  var dataIndex = row.dataIndex,
      render = row.render;

  var _React$useContext = React.useContext(ComparisonViewContext),
      currentHoveringColIndex = _React$useContext.currentHoveringColIndex;

  var title = (_row$title = row.title) !== null && _row$title !== void 0 ? _row$title : row.key;
  var rowKey = (_ref = (_row$key = row.key) !== null && _row$key !== void 0 ? _row$key : dataIndex === null || dataIndex === void 0 ? void 0 : dataIndex.toString()) !== null && _ref !== void 0 ? _ref : groupIndex;
  var contentAlignClassName = "content-align-".concat((_row$align = row.align) !== null && _row$align !== void 0 ? _row$align : 'left');
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('comparison-view-row', row.className, (_classnames = {}, _defineProperty(_classnames, 'comparison-view-header-row', row.__isHeaderRow), _defineProperty(_classnames, 'comparison-view-footer-row', row.__isFooterRow), _classnames))
  }, /*#__PURE__*/React.createElement("div", {
    "data-row-key": rowKey,
    className: classnames('comparison-view-row-cell', 'comparison-view-row-label')
  }, title), dataSource.map(function (record, recordIdx) {
    var _getColKey;

    var key = (_getColKey = getColKey(record, recordIdx)) !== null && _getColKey !== void 0 ? _getColKey : recordIdx;
    var value = !dataIndex ? null : getPathValue(record, dataIndex);
    var colClassName = getColClassName(record, recordIdx, groupIndex);
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      "data-row-key": rowKey,
      "data-col-key": key,
      className: classnames('comparison-view-row-cell', colClassName, _defineProperty({}, 'col-hover-active', currentHoveringColIndex === recordIdx)),
      onMouseEnter: function onMouseEnter(ev) {
        return onColMouseEnter(ev, record, recordIdx);
      },
      onMouseLeave: function onMouseLeave(ev) {
        return onColMouseLeave(ev, record, recordIdx);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('comparison-view-row-cell-content', contentAlignClassName)
    }, render ? render(value, record, recordIdx) : value));
  }));
}

export default RowGroup;